import React from "react";
import { Box, ListItemButton, Typography } from "@mui/material";
import { ChatThread } from "@/store/chatSlice";
import { CustomTruncateText } from "@ippon/shared-components";
import { formatTheme } from "@/theme/formatTheme";
import { getThreadPreviewText } from "./previewText";

interface CustomThreadItemProps {
  thread: ChatThread;
  isSelected: boolean;
  onClick: () => void;
  padding?: string;
  useTruncateText?: boolean;
  /** プレビュー文字数の上限。幅の広い場所では長めにする（既定15）。 */
  previewMaxLength?: number | null;
  /** true のとき、本文プレビューより title(全文)を優先表示する。 */
  preferTitle?: boolean;
}

const formatDate = (dateString: string) => {
  try {
    const date = new Date(dateString);
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${month}/${day} ${hours}:${minutes}`;
  } catch {
    return "";
  }
};

const PREVIEW_MAX_LENGTH = 15;

export const CustomThreadItem: React.FC<CustomThreadItemProps> = ({
  thread,
  isSelected,
  onClick,
  padding = "12px 20px",
  useTruncateText = true,
  previewMaxLength = PREVIEW_MAX_LENGTH,
  preferTitle = false,
}) => {
  const dateText = formatDate(thread.last_message_timestamp);
  const previewText = getThreadPreviewText(
    thread,
    previewMaxLength,
    preferTitle,
  );

  return (
    <ListItemButton
      onClick={onClick}
      disableRipple
      sx={{
        padding,
        minHeight: "72px",
        backgroundColor: isSelected
          ? formatTheme.components.chatThread.selected.background
          : formatTheme.components.chatThread.default.background,
        "&:hover": {
          backgroundColor: formatTheme.components.chatThread.selected.background,
        },
        "&.Mui-focusVisible": {
          backgroundColor: formatTheme.components.chatThread.selected.background,
        },
        "&.Mui-selected": {
          backgroundColor: formatTheme.components.chatThread.selected.background,
          "&:hover": {
            backgroundColor: formatTheme.components.chatThread.selected.background,
          },
        },
      }}
    >
      <Box sx={{ width: "100%", minWidth: 0 }}>
        <Typography
          component="div"
          sx={{
            fontSize: "14px",
            fontWeight: 700,
            color: isSelected
              ? formatTheme.components.chatThread.selected.text
              : formatTheme.components.chatThread.default.text,
            mb: "4px",
            lineHeight: 1.5,
          }}
        >
          {useTruncateText ? (
            <CustomTruncateText text={previewText} />
          ) : (
            previewText
          )}
        </Typography>
        <Typography
          component="div"
          sx={{
            fontSize: "12px",
            fontWeight: 400,
            color: formatTheme.components.chatThread.date.text,
            lineHeight: 1.5,
          }}
        >
          {dateText}
        </Typography>
      </Box>
    </ListItemButton>
  );
};
